import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { confirmable, ConfirmDialog, createConfirmation } from "react-confirm";

export interface Props {
  message?: string;
}

const Confirmation: ConfirmDialog<Props, boolean> = ({
  show,
  proceed,
  message,
}) => {
  const close = () => proceed(false);
  const open = () => proceed(true);
  return (
    <Dialog open={show} onClose={close} fullWidth maxWidth="xs">
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Disagree</Button>
        <Button onClick={open} autoFocus>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const confirm = createConfirmation(confirmable(Confirmation));
export default confirm;
